import Bowser from 'bowser'

import {
   SUPPORTED_CHROME_VERSION,
   USER_AGENT_CHROME_KEY,
   USER_AGENT_GOOGLE_SEARCH_KEY
} from '../../constants/BrowserConstants'
import { BrowserCompatibility } from '../../types'

interface ReturnType {
   getBrowserCompatibility: () => BrowserCompatibility
}

const useGetBrowserDetails = (): ReturnType => {
   const getBrowserCompatibility = (): BrowserCompatibility => {
      const parsedUa = Bowser.getParser(window.navigator.userAgent)
      const isGoogleSearch =
         parsedUa.getBrowserName() === USER_AGENT_GOOGLE_SEARCH_KEY
      const isBrowserSupported =
         parsedUa.getBrowserName() === USER_AGENT_CHROME_KEY || isGoogleSearch

      const isVersionSupported = isGoogleSearch
         ? true
         : parsedUa.satisfies({
              chrome: `>=${SUPPORTED_CHROME_VERSION}`
           })

      //NOTE: Remove hardcoded values to check browser & version support
      return {
         isBrowserSupported: true,
         isVersionSupported: true
      }
   }

   return { getBrowserCompatibility }
}

export default useGetBrowserDetails
